import { DATE_QUICK_FILTERS_LABELS, DateQuickFilters } from './helper'
import { IDateQuickFilterLabel } from './types'

export const useQuickFilterOptions = (
  quickFiltersList: (string | number | symbol)[],
  customQuickFilter: string
) => {
  const commonOptions = quickFiltersList.reduce((acc, key) => {
    acc[key] = DATE_QUICK_FILTERS_LABELS[
      key as keyof typeof quickFiltersList
    ] as IDateQuickFilterLabel

    return acc
  }, {} as { [key: string | number | symbol]: IDateQuickFilterLabel })

  if (customQuickFilter === '') {
    return commonOptions
  }

  const nextIndex = Object.keys(DateQuickFilters).length / 2 - 1

  const options = {
    ...commonOptions,
    [nextIndex]: {
      label: customQuickFilter,
      value: DateQuickFilters.DEFINED
    }
  }

  return options
}
